const endMessage = 'を入力してください。';

export const blank = (label: string): string => label + endMessage;

export const maxNumStr = (label: string, maxNum: number): string =>
  `${label}は${maxNum}字以内で入力してください。`;

export const maxNum = (label: string, maxNum: number): string =>
  `${label}は${maxNum}以内で入力してください。`;

export const minNum = (label: string, maxNum: number): string =>
  `${label}は${maxNum}以上で入力してください。`;

export const rangeNum = (
  label: string,
  minNum: number,
  maxNum: number
): string => `${label}は${minNum}以上${maxNum}以内で入力してください。`;

export const duplicate = (label: string): string =>
  `この${label}はすでに登録されています。`;

export const format = (label: string): string =>
  `${label}の形式に誤りがあります。`;

export const afterDateTime = (label: string, formatDate: string): string =>
  `${label}は${formatDate}より後の日時にして下さい。`;

export const fullWidthFormat = (label: string): string =>
  `${label}は全角で入力してください。`;

export const ascii = (label: string): string =>
  `${label}は半角英数字・記号で入力してください。`;

export const kana = (label: string): string =>
  `${label}はカタカナで入力してください。`;
